import { Form, Select } from "antd";
import { useFetchAgencyQuery } from "features/basicInfo/agencyPortal/agencySettingsAPI";
import styled from "styled-components";
import { useFetchAllDebtorUdfCustomFieldsQuery } from "features/userDefinedFields/agencyPortal/debtorUserDefinedFieldsAPI";
import UdfCustomFieldFormItem from "features/accountsTable/components/UdfCustomFieldFormItem";
import SendDialerCampaignSubForm from "./sendDialerCampaignSubForm";
import SendTextSubForm from "./sendTextSubForm";
import SkipTraceSubForm from "./skipTraceSubForm";
import DebtorTagSubForm from "./debtorTagSubForm";
import SendVoicemailSubForm from "./sendVoicemailSubForm";
import DebtorConsentSubForm from "./debtorConsentSubForm";

const StyledHeader = styled.h4`
  font-weight: 600;
  margin-top: 0px;
  margin-bottom: 8px;
`;

const StyledCard = styled.div`
  margin-bottom: 32px;
  padding-top: 8px;
`;

const StyledSelect = styled(Select)`
  max-width: 400px !important;
  margin-right: 4px;
`;

const StyledFormWrapper = styled.div`
  max-width: 400px;
`;

export default function DebtorOperationsStep({ setHideParentModal }) {
  const { data: agency = {}, isLoading: isAgencyLoading } = useFetchAgencyQuery();
  const { data: debtorCustomFields = [], isLoading: isDebtorCustomFieldsLoading } =
    useFetchAllDebtorUdfCustomFieldsQuery();

  const filterOption = (inputValue, option) => {
    const fullOptionText = option.label;
    return fullOptionText?.toLowerCase().includes(inputValue?.toLowerCase());
  };

  return (
    <StyledCard>
      <StyledHeader>Apply an operation to the debtors in bulk: </StyledHeader>
      <Form.Item
        name={["operations", "operationType"]}
        label="Operation"
        rules={[
          {
            required: true,
            message: "Please select an operation",
          },
        ]}
      >
        <StyledSelect
          showSearch
          filterOption={filterOption}
          popupMatchSelectWidth={false}
          // Operations: “Send Dialer Campaign”, “Run Skip Trace”, “Send Opt-In Text”, “Opt-Out of Text”, “Send Text Template”, “Send Email Template”
          options={[
            {
              label: "Send Dialer Campaign",
              value: "sendDialerCampaign",
            },
            {
              label: "Run Skip Trace",
              value: "skipTrace",
            },
            {
              label: "Send Text",
              value: "sendText",
            },
            {
              label: "Send Voicemail",
              value: "sendVoicemail",
            },
            {
              label: "Send Email Template",
              value: "sendEmailTemplate",
            },
            {
              label: "Update Tags",
              value: "updateDebtorTags",
            },
            {
              label: "Update Debtor Custom Fields",
              value: "updateDebtorCustomFields",
            },
            {
              label: "Update Consent Fields",
              value: "updateDebtorConsent",
            },
          ]}
          placeholder="Select one..."
          // load agency to get the default values (initialProvider) for different integrations.
          loading={isAgencyLoading}
          allowClear
        />
      </Form.Item>
      <Form.Item
        noStyle
        shouldUpdate={(prev, curr) =>
          prev?.operations?.operationType !== curr?.operations?.operationType
        }
      >
        {({ getFieldValue }) => {
          const operationType = getFieldValue(["operations", "operationType"]);

          if (operationType === "sendDialerCampaign") {
            return (
              <SendDialerCampaignSubForm
                setHideParentModal={setHideParentModal}
                operationType={operationType}
              />
            );
          }

          if (operationType === "sendText") {
            return (
              <SendTextSubForm
                setHideParentModal={setHideParentModal}
                operationType={operationType}
                initialProvider={agency?.primarySmsProvider}
              />
            );
          }

          if (operationType === "sendVoicemail") {
            return (
              <SendVoicemailSubForm
                setHideParentModal={setHideParentModal}
                operationType={operationType}
                initialProvider={agency?.primaryVoicemailProvider}
              />
            );
          }

          if (operationType === "skipTrace") {
            return (
              <SkipTraceSubForm
                setHideParentModal={setHideParentModal}
                // initialProvider={agency?.skipTraceProvider}
              />
            );
          }

          if (operationType === "updateDebtorTags") {
            return <DebtorTagSubForm />;
          }

          if (operationType === "updateDebtorConsent") {
            return <DebtorConsentSubForm />;
          }

          if (operationType === "updateDebtorCustomFields") {
            return (
              <>
                <p>Update Debtor Custom Fields</p>
                <StyledFormWrapper>
                  <Form.Item name={["operations", "updateDebtorCustomFields", "customFieldValues"]}>
                    <UdfCustomFieldFormItem
                      customFieldsData={debtorCustomFields}
                      placeholder="Add debtor custom field"
                      isLoading={isDebtorCustomFieldsLoading}
                    />
                  </Form.Item>
                </StyledFormWrapper>
              </>
            );
          }

          return null;
        }}
      </Form.Item>
    </StyledCard>
  );
}
